import Vue from 'vue';
//import store from '@/store';

export function removeVuetifyCalendarError() {
  const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
  // eslint-disable-next-line no-unused-vars
  Vue.config.warnHandler = function(msg, vm, trace) {
    if (msg === ignoreWarnMessage) {
      msg = null;
      vm = null;
      trace = null;
    }
  };
}

export function handleInternetConnectivity() {
  window.addEventListener('offline', () => {
    let payload = {
      open: true,
      text: 'No internet connection',
      color: 'error'
    };
    this.$store.commit('SET_SNACKBAR', payload);
  });

  window.addEventListener('online', () => {
    let payload = {
      open: true,
      text: 'Back online',
      color: 'success'
    };
    this.$store.commit('SET_SNACKBAR', payload);
  });
}
